
      <template>
  <div>
    <ul class="mobile-side-profile" v-if="IsUserAuthenticated">
      <li class="pfl-menu">
        <i class="ni ni-circle-08"></i>
        <span>
          {{ GetSourceName }}
        </span>
      </li>
      <li class="credit-text">
        اعتبار شما :

        <span> {{ GetSumDeposit | numFormat }} </span>
      </li>
      <li class="credit-text">
        امتیاز شما :

        <span>
          {{ GetCustomerScore | numFormat }}
        </span>
      </li>
      <li class="credit-text">
        اعتبار ریالی :

        <span>
          {{ GetCustomerValueAmount | numFormat }}
        </span>
      </li>
      <li>
        <router-link to="/profile/dashboard" class="submenu-text"
          >پروفایل
        </router-link>
      </li>
      <li><a @click="SignOut()" class="submenu-text exit-account">خروج</a></li>
    </ul>
  </div>
</template>
<script>
import store from "@/views/profile/store/index";

export default {
  name: "PdkToplineMob",
  store: store,
  data() {
    return {
      isAuthenticated: false,
      userId: "",
      sources: [],
      topline: [],
      userRoles: [],
      customerClubData: {},
      isShowModal: false,
      showintroductionModalCount: 1,
    };
  },

  computed: {
    IsUserAuthenticated() {
      return this.$store.getters.IsUserAuthenticated;
    },
    GetUsername() {
      return this.$store.getters.GetUsername;
    },
    GetSourceName() {
      if (localStorage.getItem("SourceIdInReport") != null)
        return this.$store.getters.GetSourceName;
      else return "";
    },
    GetSumDeposit() {
      if (localStorage.getItem("SourceIdInReport") != null)
        return this.$store.getters.GetSumDeposit;
      else return 0;
    },
    GetSourceDeposit() {
      return this.$store.getters.GetSelectedSourceDeposit;
    },
    GetSourceId() {
      return localStorage.getItem("SourceIdInReport");
    },
    GetCustomerScore() {
      return this.$store.getters.GetCustomerClubData.score;
    },
    GetCustomerValueAmount() {
      return this.$store.getters.GetCustomerClubData.valueAmount;
    },
  },
  created() {
    this.checkForLogin();
    this.getUserId();
    this.checkSources();
  },
  mounted() {
    $(".exit-account").on("click", function () {
      $(".users-menu").toggleClass("shown");
    });
  },
  methods: {
    checkForLogin() {
      this.$store.dispatch("checkForLogin");
    },
    SignOut() {
      this.$store.dispatch("signOut").then(() => {
        if (this.$route.name != "main home") this.$router.push("/");
      });
      // this.$store.dispatch("fillCheckMenuList", false);
      this.$store.state.customerClubData = {};
      this.$store.dispatch("fillCheckMenuList", false);
      console.log(this.$store.state.customerClubData);
      localStorage.clear();
    },
    async getUserId() {
      this.userId = this.$store.getters.GetUserId;
    },
    async checkSources() {
      const isAuthenticated = this.$store.getters.IsUserAuthenticated;
      if (isAuthenticated) {
        this.sources = this.$store.getters.GetAllSourceConfirmed;
        this.customerClubData = this.$store.getters.GetCustomerClubData;

        if (this.sources.length == 0) {
          this.getAllSource();
        }

        // if (Object.keys(this.customerClubData).length == 0) {
        //   this.getCustomerDataByBusiness();
        // }
      }
    },

    async getAllSource() {
      this.$store.dispatch("getAllSourceConfirmed", this.userId).then((res) => {
        this.sources = res;
        // setDefulatSource
        if (this.sources != null) {
          this.$store.dispatch("getDepositInCrs", this.sources[0].id);
        }
      });
    },
    // async getCustomerDataByBusiness() {
    //   const res = await this.$store.dispatch(
    //     "getProfileByProfileId",
    //     this.userId
    //   );
    //     if (res.data !== "") {
    //     if (
    //       res.data.profileId != "00000000-0000-0000-0000-000000000000" &&
    //       parseInt(localStorage.getItem("IntroductionModalCount")) === 1
    //     )
    //       this.isShowModal = true;

    //     localStorage.setItem("IntroductionModalCount", 0);
    //   }
    // },
    closeModal() {
      this.isShowModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-side-profile {
  padding: 30px 8px;
  li {
    list-style: none;
    padding: 15px 12px;
    border-bottom: 1px solid #f1f1f1;
    font-weight: 500;

    &.pfl-menu {
      padding-bottom: 25px;
      border-bottom: 1px ridge #d4d9e7;
      margin-bottom: 20px;

      i {
        font-size: 35px;
        vertical-align: middle;
        color: #f8ca4e;
        margin-left: 10px;
      }
    }

    span {
      color: #3c5eb3;
      margin-left: 10px;
    }
    &:last-child {
      border-bottom: none !important;
    }
  }
}
</style>